import React, { useState, useEffect } from "react";

export function Kliping() {
	

	return (<>

	</>);
}
